import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Gmap from "./Gmap";
import Select, { components } from "react-select";
import Slider from "@mui/material/Slider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  propertyFeaturesOptions,
  itemConditionOptions,
  techCategoryOptions,
  approximateAgeOptions,
  colorOptions,
  itemPickupDeliveryOptions,
  sellerTypeOptions
} from "../contants/data";
import useToggle from "../hooks/useToggle";
// ICONS
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";

const FiltersMobile = ({ onFilter, data, stateCategory, filters }) => {
  const [thunks, setThunks] = useState(null);
  const [showAdvFilter, setShowAdvFilter] = useState(false);
  const { isFilter } = useSelector((state) => state[stateCategory]);
  const [selectedOption, setSelectedOption] = useState(null);

  const dispatch = useDispatch();

  const handleRemoveOption = (removedOption) => {
    const updatedOption = selectedOption.filter(
      (option) => option !== removedOption
    );
    setSelectedOption(updatedOption);
  };

  // GEOLOCATE
  const { lat, lng, radius } = useSelector(
    (state) => state[stateCategory].filters.location
  );

  // NEW LAT,LNG
  const [newLat, setNewLat] = useState("");
  const [newLng, setNewLng] = useState("");

  // PRICE
  const { min: priceMin, max: priceMax } = useSelector(
    (state) => state[stateCategory].filters.price_range
  );
  const [priceVal, setPriceVal] = useState([priceMin, priceMax]);
  const [togglePrice, handleTogglePrice] = useToggle();
  const handlePriceChange = (event, newValue) => {
    setPriceVal(newValue);
    dispatch(thunks?.changePrice({ min: newValue[0], max: newValue[1] }));
  };

  // Category
  const { category } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [toggleCategory, handleToggleCategory] = useToggle();
  const handleCategoryChange = (options) => {
    setSelectedCategory(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changeCategory(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Item Condition
  const { itemCondition } = useSelector((state) => state[stateCategory].filters);
  const [selectedItemCondition, setSelectedItemCondition] = useState([]);
  const [toggleItemCondition, handleToggleItemCondition] = useToggle();
  const handleItemConditionChange = (options) => {
    setSelectedItemCondition(options ? options.map((option) => option.value) : []);
    dispatch(
        thunks?.changeItemCondition(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Approximate Age
  const { approximateAge } = useSelector((state) => state[stateCategory].filters);
  const [selectedApproximateAge, setSelectedApproximateAge] = useState([]);
  const [toggleApproximateAge, handleToggleApproximateAge] = useToggle();
  const handleApproximateAgeChange = (options) => {
    setSelectedApproximateAge(options ? options.map((option) => option.value) : []);
    dispatch(
        thunks?.changeApproximateAge(
        options ? options.map((option) => option.value) : []
      )
    );
  };

    // Color
    const { color } = useSelector((state) => state[stateCategory].filters);
    const [selectedColor, setSelectedColor] = useState([]);
    const [toggleColor, handleToggleColor] = useToggle();
    const handleColorChange = (options) => {
      setSelectedColor(options ? options.map((option) => option.value) : []);
      dispatch(
          thunks?.changeColor(
          options ? options.map((option) => option.value) : []
        )
      );
    };

  // Item Pickup/Delivery
  const { itemPickupDelivery } = useSelector((state) => state[stateCategory].filters);
  const [selectedItemPickupDelivery, setSelectedItemPickupDelivery] = useState([]);
  const [toggleItemPickupDelivery, handleItemPickupDelivery] = useToggle();
  const handleItemPickupDeliveryChange = (options) => {
    setSelectedItemPickupDelivery(options ? options.map((option) => option.value) : []);
    dispatch(
        thunks?.changeItemPickupDelivery(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Seller Type
  const { sellerType } = useSelector((state) => state[stateCategory].filters);
  const [selectedSellerType, setSelectedSellerType] = useState([]);
  const [toggleSellerType, handleToggleSellerType] = useToggle();
  const handleSellerTypeChange = (options) => {
    setSelectedSellerType(options ? options.map((option) => option.value) : []);
      dispatch(
          thunks?.changeSellerType(
          options ? options.map((option) => option.value) : []
        )
      );
  };

  // Property Features
  const { propertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedPropertyFeatures, setSelectedPropertyFeatures] = useState([]);
  const [togglePropertyFeatures, handleTogglePropertyFeatures] = useToggle();
  const handlePropertyFeaturesChange = (options) => {
    setSelectedPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changePropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };


  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === "tech") {
        importedThunks = await import("../store/slices/tech.slice");
      } 
      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  if (!thunks) {
    return <div>Loading...</div>;
  }

  const handleSubmit = () => {
    let finalLat = "";
    let finalLng = "";
    if ((newLat != "") & (newLng != "")) {
      finalLat = newLat;
      finalLng = newLng;
      dispatch(thunks?.changeLocation({ lat: finalLat, lng: finalLng }));
    } else {
      finalLat = lat;
      finalLng = lng;
    }

    onFilter({
      finalLat,
      finalLng,
      radius,
      priceVal,
      category,
      itemCondition,
      approximateAge,
      color,
      propertyFeatures,
    });
    dispatch(thunks?.activateFilter(true));
    dispatch(thunks?.setSearchTerm(""));
    dispatch(thunks?.setSortBy("Closest to Me"));
    dispatch(thunks?.resetSortedData());
  };

  const updateLoc = (lat, lng) => {
    setNewLat(() => {
      return lat;
    });
    setNewLng(() => {
      return lng;
    });
  };

  const handleResetFilter = () => {
    window.location.reload();
  };

  const handleShowAdvFilter = () => {
    setShowAdvFilter(!showAdvFilter);
  };

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      fontSize: "14px", // Remove the border
      boxShadow: state.isFocused ? "none" : provided.boxShadow, // Remove the box shadow on focus
      "&:hover": {
        borderColor: "none", // Remove border color on hover
      },
      cursor: "pointer", // Change cursor to pointer to indicate interaction
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the indicator separator
    }),
    dropdownIndicator: () => ({
      display: "none", // Hide the dropdown indicator
    }),
    input: () => ({
      display: "none", // Hide the input field
    }),
  };

  return (
    <div className="sidebar mobile hide-desktop">
      <Gmap onChangeLoc={updateLoc} data={data} />
      {filters.includes("Price") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Price</label>
            <span>
              {!togglePrice && (
                <div className="price-range-wrap mt-0">
                  <span>${priceVal[0].toLocaleString("en-US")} - </span>
                  <span>${priceVal[1].toLocaleString("en-US")}</span>
                </div>
              )}
            </span>
            <button className="btn-toggle" onClick={handleTogglePrice}>
              {togglePrice ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {togglePrice && (
            <>
              <Slider
                value={priceVal}
                onChange={handlePriceChange}
                valueLabelDisplay="auto"
                max={20000}
                step={10}
              />
              <div className="price-range-wrap mt-0 ">
                <span>${priceVal[0].toLocaleString("en-US")} - </span>
                <span>${priceVal[1].toLocaleString("en-US")}</span>
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes("Category") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Category</label>
            <span>
              {!toggleCategory && (
                <Select
                  options={techCategoryOptions}
                  onChange={handleCategoryChange}
                  value={techCategoryOptions.filter((option) =>
                    selectedCategory.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleToggleCategory}
            >
              {toggleCategory ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleCategory && (
            <Select
              isMulti
              options={techCategoryOptions}
              onChange={handleCategoryChange}
              value={techCategoryOptions.filter((option) =>
                selectedCategory.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Item Condition") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Item Condition</label>
            <span>
              {!toggleItemCondition && (
                <Select
                  options={itemConditionOptions}
                  onChange={handleItemConditionChange}
                  value={itemConditionOptions.filter((option) =>
                    selectedItemCondition.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleToggleItemCondition}
            >
              {toggleItemCondition ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleItemCondition && (
            <Select
              isMulti
              options={itemConditionOptions}
              onChange={handleItemConditionChange}
              value={itemConditionOptions.filter((option) =>
                selectedItemCondition.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Approximate Age") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Approximate Age</label>
            <span>
              {!toggleApproximateAge && (
                <Select
                  options={approximateAgeOptions}
                  onChange={handleApproximateAgeChange}
                  value={approximateAgeOptions.filter((option) =>
                    selectedApproximateAge.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleToggleApproximateAge}
            >
              {toggleApproximateAge ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleApproximateAge && (
            <Select
              isMulti
              options={approximateAgeOptions}
              onChange={handleApproximateAgeChange}
              value={approximateAgeOptions.filter((option) =>
                selectedApproximateAge.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Color") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Color</label>
            <span>
              {!toggleColor && (
                <Select
                  options={colorOptions}
                  onChange={handleColorChange}
                  value={colorOptions.filter((option) =>
                    selectedColor.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleToggleColor}
            >
              {toggleColor ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleColor && (
            <Select
              isMulti
              options={colorOptions}
              onChange={handleColorChange}
              value={colorOptions.filter((option) =>
                selectedColor.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Item Pickup/Delivery") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Item Pickup/Delivery</label>
            <span>
              {!toggleItemPickupDelivery && (
                <Select
                  options={itemPickupDeliveryOptions}
                  onChange={handleItemPickupDeliveryChange}
                  value={itemPickupDeliveryOptions.filter((option) =>
                    selectedItemPickupDelivery.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleItemPickupDelivery}
            >
              {toggleItemPickupDelivery ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleItemPickupDelivery && (
            <Select
              isMulti
              options={itemPickupDeliveryOptions}
              onChange={handleItemPickupDeliveryChange}
              value={itemPickupDeliveryOptions.filter((option) =>
                selectedItemPickupDelivery.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Seller Type") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Seller Type</label>
            <span>
              {!toggleSellerType && (
                <Select
                  options={sellerTypeOptions}
                  onChange={handleSellerTypeChange}
                  value={sellerTypeOptions.filter((option) =>
                    selectedSellerType.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleToggleSellerType}
            >
              {toggleSellerType ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {toggleSellerType && (
            <Select
              isMulti
              options={sellerTypeOptions}
              onChange={handleSellerTypeChange}
              value={sellerTypeOptions.filter((option) =>
                selectedSellerType.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}

      {filters.includes("Property Features") && (
        <div className="form-control-wrap">
          <div className="label-2-cols">
            <label>Property Features</label>
            <span>
              {!togglePropertyFeatures && (
                <Select
                  options={propertyFeaturesOptions}
                  onChange={handlePropertyFeaturesChange}
                  value={propertyFeaturesOptions.filter((option) =>
                    selectedPropertyFeatures.includes(option.value)
                  )}
                  placeholder="Select"
                  styles={selectStyles}
                  menuIsOpen={false}
                  className="border-0"
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className="btn-toggle"
              onClick={handleTogglePropertyFeatures}
            >
              {togglePropertyFeatures ? "Hide Filter" : "Edit Filter"}
            </button>
          </div>
          {togglePropertyFeatures && (
            <Select
              isMulti
              options={propertyFeaturesOptions}
              onChange={handlePropertyFeaturesChange}
              value={propertyFeaturesOptions.filter((option) =>
                selectedPropertyFeatures.includes(option.value)
              )}
              className="border-0"
            />
          )}
        </div>
      )}
      <button onClick={() => handleSubmit()} className="primary mb-10">
        Filter
      </button>
      <button
        onClick={() => handleResetFilter()}
        className="reset"
        disabled={!isFilter}
      >
        Reset Filter
      </button>
    </div>
  );
};

export default FiltersMobile;
